// Tipo de una máquina del Parque de Maquinaria — catálogo cerrado, orden alfabético
export const TipoMaquinariaArray = [
  { id: "ACAMADORA", display: "ACAMADORA" },
  { id: "ACOLCHADORA", display: "ACOLCHADORA" },
  { id: "APLICADOR", display: "APLICADOR" },
  { id: "ARADO", display: "ARADO" },
  { id: "ASPERSORA", display: "ASPERSORA" },
  { id: "ATOMIZADOR", display: "ATOMIZADOR" },
  { id: "AUTOTRAC", display: "AUTOTRAC" },
  { id: "BIULER", display: "BIULER" },
  { id: "BOLILLO", display: "BOLILLO" },
  { id: "BORDERO", display: "BORDERO" },
  { id: "CANALERA", display: "CANALERA" },
  { id: "CARGADOR FRONTAL", display: "CARGADOR FRONTAL" },
  { id: "CHIPEADORA", display: "CHIPEADORA" },
  { id: "CORTADORA", display: "CORTADORA" },
  { id: "CUADRO NIVELADOR", display: "CUADRO NIVELADOR" },
  { id: "CULTIVADOR", display: "CULTIVADOR" },
  { id: "CULTIVADORA", display: "CULTIVADORA" },
  { id: "DESMENUSADORA", display: "DESMENUSADORA" },
  { id: "DESVARADORA", display: "DESVARADORA" },
  { id: "DRONE", display: "DRONE" },
  { id: "EMPACADORA", display: "EMPACADORA" },
  { id: "EMPLASTICADORA", display: "EMPLASTICADORA" },
  { id: "ENSILADORA", display: "ENSILADORA" },
  { id: "ESCREPA NIVELADORA", display: "ESCREPA NIVELADORA" },
  { id: "ESPARCIDOR FERTILIZADOR", display: "ESPARCIDOR FERTILIZADOR" },
  { id: "FERTILIZADORA", display: "FERTILIZADORA" },
  { id: "FUMIGADORA", display: "FUMIGADORA" },
  { id: "IGRADE", display: "IGRADE" },
  { id: "IMPLEMENTO", display: "IMPLEMENTO" },
  { id: "JARDINERO", display: "JARDINERO" },
  { id: "JDLINK", display: "JDLINK" },
  { id: "MAQUINARIA", display: "MAQUINARIA" },
  { id: "MOLINO PARA MOLIENDA", display: "MOLINO PARA MOLIENDA" },
  { id: "MOTOCULTOR", display: "MOTOCULTOR" },
  { id: "NODRIZA COMPLETA", display: "NODRIZA COMPLETA" },
  { id: "NULL", display: "NULL" },
  { id: "PICADORA CORTADORA DE FORRAJE", display: "PICADORA CORTADORA DE FORRAJE" },
  { id: "PODADORA", display: "PODADORA" },
  { id: "RASRILLO", display: "RASRILLO" },
  { id: "RASTRA", display: "RASTRA" },
  { id: "RASTRILLO AGRICOLA DE FORRAJE", display: "RASTRILLO AGRICOLA DE FORRAJE" },
  { id: "RASTRILLO COSECHADORA", display: "RASTRILLO COSECHADORA" },
  { id: "RED_CONTROLLER", display: "RED_CONTROLLER" },
  { id: "REMOLQUE", display: "REMOLQUE" },
  { id: "REMOLQUE AGRICOLA", display: "REMOLQUE AGRICOLA" },
  { id: "REMOLQUE CAMA BAJA", display: "REMOLQUE CAMA BAJA" },
  { id: "REMOLQUE GANADERO", display: "REMOLQUE GANADERO" },
  { id: "REMOLQUE PLATAFORMA", display: "REMOLQUE PLATAFORMA" },
  { id: "RETRO EXCAVADORA", display: "RETRO EXCAVADORA" },
  { id: "RIEGO", display: "RIEGO" },
  { id: "SEEDSTAR2", display: "SEEDSTAR2" },
  { id: "SEGADORA ACONDICIONADORA", display: "SEGADORA ACONDICIONADORA" },
  { id: "SEMBRADORA", display: "SEMBRADORA" },
  { id: "SUBSUELO", display: "SUBSUELO" },
  { id: "SURCADOR", display: "SURCADOR" },
  { id: "TRACTOR", display: "TRACTOR" },
  { id: "TRACTOR AGRICOLA", display: "TRACTOR AGRICOLA" },
  { id: "TRILLADORA", display: "TRILLADORA" },
  { id: "TRITURADOR DE CUCHILLAS", display: "TRITURADOR DE CUCHILLAS" },
  { id: "ZANJADORA AGRICOLA", display: "ZANJADORA AGRICOLA" },
];
